
import { isEmpty } from 'es-toolkit/compat';

export function getDomain() {
  return 'exploretock';
}

export function removeQueryParams(url: string) {
  return url.split('?')[0];
}

export function ensureHttpPrefix(fullUrl: string): string {
  if (isEmpty(fullUrl) || fullUrl.startsWith('https://') || fullUrl.startsWith('http://')) {
    return fullUrl;
  }
  return 'http://' + fullUrl;
}
